// extracted by mini-css-extract-plugin
export var base = "_4r-0";
export var updateBanner = "_4r-1";